import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-banner"
export default class extends Controller {
  connect() {
    // Banner stays visible until manually dismissed or profile created
  }

  dismiss() {
    // Slide up and fade out
    this.element.style.transform = "translateY(-100%)"
    this.element.style.opacity = "0"

    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  // Allow manual dismiss
  close(event) {
    event.preventDefault()
    this.dismiss()
  }
}
